import React from 'react';

const ReferenceCatalogueNumber = ({
    AppContext,
    fieldTitle = "Reference / Catalogue number"
}) => {

	return <>

		<div className="view-task-field">
            <div className="view-task-field-line">
                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">

                    <input type="text" className="form-control rounded-0 form-control-md" disabled title="You can edit this in the Product Details" value={AppContext.currentItem.SKUProductCode} />

                </div>
            </div>
        </div>


		
	</>
}


export default ReferenceCatalogueNumber;
